import classNames from "classnames";
import React, { FunctionComponent, ReactElement, ReactNode } from "react";
import { ReactComponent as IconAlert } from "../../../icons/alert-triangle.svg";
import "./style.scss";

interface Props {
  children: ReactNode;
  icon?: ReactNode;
  title?: string | ReactElement;
  type?: "error" | "warning";
}

const ContentNotification: FunctionComponent<Props> = ({
  children,
  icon = <IconAlert />,
  title,
  type = "warning",
}) => {
  return (
    <div
      className={classNames("ContentNotification", {
        "ContentNotification--error": type === "error",
        "ContentNotification--warning": type === "warning",
      })}
    >
      <div className="ContentNotification-icon">{icon}</div>
      <div className="ContentNotification-content">
        <div className="ContentNotification-content-title">{title}</div>
        <div className="ContentNotification-content-detail">{children}</div>
      </div>
    </div>
  );
};

export default ContentNotification;
